import { typeInfo } from "../../../../constants/typeInfo";

const TypeBox = ({ type, isMobile }) => {
  return (
    <div
      style={{
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: 800,
        padding: isMobile ? "4px 14px" : "6px 18px",
        color: typeInfo[type].color,
        backgroundColor: typeInfo[type].backgroundColor,
        borderRadius: "999px",
        whiteSpace: "nowrap",
        letterSpacing: "-0.01em",
      }}
    >
      {typeInfo[type].text}
    </div>
  );
};

export default TypeBox;
